import { memo, type ReactNode } from 'react'

import { cn } from '@/lib/utils'

import { DataTableSkeleton } from './data-table-skeleton.molecule'

interface DataTableLoadingProps {
  toolbar: ReactNode
  columnCount: number
  hasCheckbox: boolean
  hasActions: boolean
  className?: string
}

/**
 * Renders the data table loading state with skeleton.
 */
const DataTableLoadingBase: React.FC<DataTableLoadingProps> = ({
  toolbar,
  columnCount,
  hasCheckbox,
  hasActions,
  className,
}): ReactNode => (
  <div className={cn('data-table-wrapper space-y-4', className)}>
    {toolbar}
    <DataTableSkeleton
      columnCount={columnCount}
      hasCheckbox={hasCheckbox}
      hasActions={hasActions}
    />
  </div>
)

export const DataTableLoading = memo(DataTableLoadingBase)

DataTableLoading.displayName = 'DataTableLoading'
